import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { UserRole } from '../../../core/enums/user-role.enum';

// Precisa bater com o breakpoint em que .nav-links / .auth-actions somem no SCSS
const MOBILE_BREAKPOINT = 900;

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    RouterModule
  ],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  currentUser$ = this.authService.currentUser$;
  mobileMenuOpen = false;
  scrolled = false;

  get isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  get isEventAdmin(): boolean {
    const user = this.authService.getUser();
    return user?.role === UserRole.EVENT_ADMIN || user?.role === UserRole.ADMIN;
  }

  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
  }

  logout(): void {
    this.closeMobileMenu();
    this.authService.logout();
    this.router.navigate(['/events']);
  }

  getUserRoleLabel  (role: UserRole): string {
    return role === UserRole.EVENT_ADMIN ? 'Administrador de Eventos' : role === UserRole.ADMIN ? 'Administrador' : role === UserRole.ATHLETE ? 'Atleta' : '';
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.scrolled = window.scrollY > 8;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.mobileMenuOpen && window.innerWidth > MOBILE_BREAKPOINT) {
      this.mobileMenuOpen = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMobileMenu();
  }
}
